import React from 'react'
import { useRouter } from 'next/router'
// Components
import BasicHeadSeo from '@/components/basicHeadSeo'
import Header from '@/components/newHeader/Header'
import LandingHero from '@/components/vets/LandingHero'
import MoreInformation from '@/components/vets/MoreInformation'
import RelatedBlog from '@/components/vets/RelatedBlog'
import Footer from '@/components/newFooter/newFooter'
import SearchResult from '@/components/vets/SearchResult/SearchResult'
// Utils
import { getAllPosts } from '@/components/blog/lib/cosmic'
import { categorizePosts } from '@/components/blog/lib/utils'
import { citiesByState } from '@/utils/countries_and_states'

import { ROBOTS_META } from 'const'
import { PostDataType } from '@types'

import styles from '../index.module.scss'

export default function States({ posts }: { posts: PostDataType[] }) {
  const categorizedPosts = (categorizePosts(posts) || {}) as Record<string, PostDataType[]>
  const router = useRouter()
  const statePath = Array.isArray(router.query.state)
    ? router.query.state[0].toUpperCase()
    : router.query.state.toUpperCase()

  const data = citiesByState
  const dataState =
    data[1].states.filter((elem) => elem.state_code === statePath).length > 0
      ? data[1].states.filter((elem) => elem.state_code === statePath)
      : data[0].states.filter((elem) => elem.state_code === statePath)

  return (
    <>
      <BasicHeadSeo
        title={`Find a Vet in ${dataState[0].name} | MawooPets.com`}
        description={`Looking for a reputable veterinarian in [state]? Our Mawoo Pets veterinary directory is here to help you find some of the best vets and animal clinics in ${dataState[0].name}.`}
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/find-a-vet/${statePath}`}
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        content={ROBOTS_META}
      />
      <div className={styles.main}>
        <Header />
        <LandingHero state={statePath} citiesByState={citiesByState} />
        <SearchResult state={statePath} citiesByState={citiesByState} />
        <MoreInformation state={statePath} citiesByState={citiesByState} />
        {/* <Questions /> */}
        <RelatedBlog categorizedPosts={categorizedPosts} />
        <Footer />
      </div>
    </>
  )
}

export async function getServerSideProps() {
  try {
    const posts = await getAllPosts()

    return {
      props: {
        posts,
      },
    }
  } catch (err) {
    console.error(err)
    throw err
  }
}
